import { useChat } from '@/contexts/chat-context';
import { Tooltip } from '@nextui-org/react';
import { IoMdClipboard, IoMdClose } from 'react-icons/io';

type ChatHeaderProps = {
  title?: string;
  onClose?: () => void;
  actions?: React.ReactNode;
};

export const ChatHeader = ({ title = 'Coach Tivy', actions, onClose }: ChatHeaderProps) => {
  return (
    <div className="flex items-center justify-between p-6 bg-brandSecondaryBlue">
      <h2 className="text-base leading-5 font-semibold text-white">{title}</h2>

      <div className="flex items-center justify-end gap-4">
        {actions}
        <ChatHeaderCopyButton />
        {onClose && <ChatHeaderCloseButton onClick={onClose} />}
      </div>
    </div>
  );
};

export const ChatHeaderCloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Tooltip content="Close chat" color="foreground">
      <button onClick={onClick} className="rounded-full p-1 bg-white/80 hover:bg-white cursor-pointer group">
        <IoMdClose className="text-brandSecondaryBlue group-hover:text-gray-700" />
      </button>
    </Tooltip>
  );
};

export const ChatHeaderCopyButton = () => {
  const { onCopyChat } = useChat();

  return (
    <Tooltip content="Copy chat" color="foreground">
      <button onClick={onCopyChat} className="rounded-full p-1 bg-white/80 hover:bg-white cursor-pointer group">
        <IoMdClipboard className="text-brandSecondaryBlue group-hover:text-gray-700" />
      </button>
    </Tooltip>
  );
};
